import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import { Row, Col, Box } from "@intechprev/componentes-web";

import { Page } from "..";
import { HomeCard } from "../Home/HomeCard";

import { PlanoVinculadoService } from "../../services";

import { Extrato } from "./Extrato";
import { Resgate } from "./Resgate";
import { Portabilidade } from "./Portabilidade";
import { PlanoVinculadoEntidade } from "../../entidades";

export { Extrato, Resgate, Portabilidade }

interface Props { }

interface State {
    plano: PlanoVinculadoEntidade;
}

export class Plano extends React.Component<Props, State> {
    private page = React.createRef<Page>();

    constructor(props: Props) {
        super(props);

        this.state = {
            plano: new PlanoVinculadoEntidade()
        }
    }

    componentDidMount = async() => {
        this.page.current.loading(true);

        var planos = await PlanoVinculadoService.Buscar();
        var plano = planos[0];

        this.setState({ 
            plano
         });

        this.page.current.loading(false);
    }

    render() {
        return (
            <Page {...this.props} ref={this.page}>
                {this.page.current &&
                    <div>
                        <Row>
                            <Col>
                                <HomeCard titulo={"Plano"}>
                                    {this.state.plano.DS_PLANO_PREVIDENCIAL}
                                </HomeCard>
                            </Col>

                            <Col>
                                <HomeCard titulo={"Situação"}>
                                    {this.state.plano.DS_SIT_PLANO}
                                </HomeCard>
                            </Col>

                            <Col>
                                <HomeCard titulo={"Data de Inscrição"}>
                                    {moment(this.state.plano.DT_INSC_PLANO, "DD/MM/YYYY").format("DD/MM/YYYY")}
                                </HomeCard>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col tamanho={"12"}>
                                <Box titulo={"Extrato"}>
                                    <h5>Visualize e baixe o seu extrato de contribuições atualizado</h5>
                                    <Link className="btn btn-primary btn-block mt-3" id="esqueciSenha" to="/extrato">Ir para Extrato</Link>
                                </Box>
                            </Col>
                            
                            {/* <Col tamanho={"sm-12"} className={"col-md-4"}>
                                <Box titulo={"Simulador de Resgate"}>
                                    <h5>Simule o valor atualizado do seu resgate de contribuições</h5>
                                    <Link className="btn btn-primary btn-block mt-3" id="esqueciSenha" to="/resgate">Ir para Simulador de Resgate</Link>
                                </Box>
                            </Col>
                            
                            <Col tamanho={"sm-12"} className={"col-md-4"}>
                                <Box titulo={"Simulador de Portabilidade"}>
                                    <h5>Simule o valor atualizado do seu saldo para portabilidade</h5>
                                    <Link className="btn btn-primary btn-block mt-3" id="esqueciSenha" to="/portabilidade">Ir para Simulador de Portabilidade</Link>
                                </Box>
                            </Col> */}
                        </Row>
                    </div>
                }
            </Page>
        );
    }
}